import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeaderWithToken } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";

export async function ObtenerUnidadConsultor(idunidad){
    const URL = `${configData.SERVER_URL}FormularioController/Informacion/UnidadConsultor/${idunidad}`;
    var userData:UserData = authenticationService.currentUserValue;
    var datos:string = "";

    try {
        const respuesta = await axios.get(URL,{
            headers:authHeaderWithToken(userData.token),
        })

       datos = respuesta.data;
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            ;
        }
    }
    return datos;
}
